import { getMessages } from '../../../../../../../../store/constants';

export const CARD_PREVIEW_CARD_NAME = getMessages().getText('cardNumber.card_preview.name');
